import Api from '@/axios'

export default {
  getAllPromotions () {
    return Api().get('promotions')
  },
  getAllPromotionsList() {
    return Api().get('promotions/select/list')
  },
  getPromotionDetails (id) {
    return Api().get(`promotions/${id}`)
  },
  addPromotion (payload) {
    return Api().post('promotions', payload)
  },
  editPromotion (id, payload) {
    return Api().post(`promotions/${id}`, payload)
  },
  reAdd (id, payload) {
    return Api().post(`promotions/${id}/re-add`, payload)
  }
}
